<template>
    <!-- 主观题 -->
    <div class="subjectiveConte">
        <div v-for="(item,index) in questionlist" :key="index">
            <!-- 问答题 -->
            <QsAndAns v-show="item.questiontype == 6" :type="type" :itmData="item" ref="QsAndAns" />
            <!-- 材料题 -->
            <MaterialQuestions :itmData="item" :type="type" v-show="item.questiontype == 7 && item.hasSubject" />
        </div>
    </div>
</template>
<script>
import QsAndAns from './qsAndAns.vue'
import MaterialQuestions from './qsAndAns.vue'
export default {
    data(){
        return {
    
        }
    },
    components : {
        QsAndAns,
        MaterialQuestions
    },
    mounted(){
        console.log(this.questionlist,'pp')
    },
    props: ['questionlist', 'type'],
    methods: {
        submit(){
            
        }
    }
}
</script>